/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

//library imports
import { Component, createRef } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import DatePicker from "react-datepicker";
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import axios from 'axios';

//project imports
import Datatable from 'shared/datatable';
import { invoiceList } from 'shared/settings/apiconfig';
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { itemimagelist,locationlist } from 'shared/settings/apiconfig';
import { ArrayValueReorder } from 'shared/modifiers';


//style imports
import './InvoiceList.scss';

/**
 * this page is used to show invoice as list
 * 
 * @param props
 * 
 * @return  invoice list html code
 * 
**/

class InvoiceList extends Component {

    config;
    status = { 'paid': 'text-success', 'unpaid': 'text-danger' };

    constructor(props) {
        super(props);
        this.initialSearchState = {
            firstname: { field: 'firstname', value: '', op: 'LIKE', join: 'AND' },
            lastname: { field: 'lastname', value: '', op: 'LIKE', join: 'AND' },
            invoicenumber: { field: 'invoicenumber', value: '', op: '=', join: 'AND' },
            saletitle: { field: 'saletitle', value: '', op: 'LIKE', join: 'AND' },
            fromdate: { field: 'createddate', value: '', op: '>=', join: 'AND' },
            todate: { field: 'createddate', value: '', op: '<=', join: 'AND' },
            // invoicestatus: { field: 'invoicestatus', value: '', op: '=', join: 'AND' },
            itemtitle: { field: 'itemtitle', value: '', op: 'LIKE', join: 'AND' },
            buyeremail: { field: 'buyeremail', value: '', op: 'LIKE', join: 'AND' },
            locationid: { field: 'locationid', value: "", op: '=', join: 'AND' },
        }
        this.state = {
            locations: [],
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
            tableData:[],
            imageList: [],
            displayImage: {},
            PageSize : 10
        }

        this.config = {
            name: 'invoice',
            url: `${invoiceList}`,
            params: {},
            createurl: '/invoice/create',
            columns: [
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['view', 'edit'],  customHeader: <> <div><Button className="save-button" style={{ margin: "10%" }} onClick={() => this.navigateToCreate()}>+ Create</Button></div> </>, width: '150px',
                    actionEvents: { 
                        edit: (row, state) => {
                            let data = {}
                            data['datatable'] = this.state.tableData.stateData;
                            data['PageSize'] = this.state.PageSize
                            this.props.history.push({ pathname: `invoice/edit/${row['id']}`, state: data }) 
                        }, 
                        view: (row, state) => { 
                            let data = {}
                            data['datatable'] = this.state.tableData.stateData;
                            data['name'] = 'Invoice'
                            data['PageSize'] = this.state.PageSize
                            this.props.history.push({pathname: row['type'] == 'RA' ? `invoice/ra/view/${row['id']}` : row['type'] == 'DG' ? `invoice/dg/view/${row['id']}` : `invoice/view/${row['id']}`, state: data}) } 
                        },
                        actionEnableOn: { edit: (row) => this.editAction(row) }
                },
                { name: 'Status', property: 'invoicestatus', sort: true, width: '130px', columnType: 'custom', customColumn: this.customStatus },
                { name: 'Amount', property: 'invoiceamount', sort: false, width: '130px', columnType: 'custom', customColumn: this.customAmount },
                { name: 'Pending Amount', property: 'pendingamount', sort: false, width: '130px', columnType: 'custom', customColumn: this.customPendingAmount },
                { name: 'Invoice ID', property: 'invoicenumber', sort: true, sortType: 'num', width: '130px' },
                { name: 'Buyer', property: 'buyername', sort: false, width: '130px', columnType: 'custom', customColumn: this.customBuyerName },
                { name: 'Buyer Email', property: 'email', sort: false, width: '180px', columnType: 'custom', customColumn: this.customEmail },
                { name: 'Sale Title', property: 'saletitle', sort: true, width: '200px' },
                // { name: 'Type', property: 'type', sort: true, width: '130px' },
                // { name: 'Tracking ID', property: 'trackshippingid', sort: true, width: '130px' },
                { name: 'Date', property: 'createddate', sort: true, width: '130px', columnType: 'custom', customColumn: this.customDate },
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['accordion'], customHeader: <></>, width: '100px',
                    accordion: this.accordionValue,
                },
                
            ],
            sort: [{ field: 'id', direction: 'desc' }],
            pagination: true
        };
        this.accordionHead = {
            title: "Items",
            amount: "Amount",
            tax: "Tax",
            taxamount: "Tax Amount",
            buyerspremium: "BP",
            buyerspremiumamount: "BP Amount",
            grossamount: "Gross Amount"
        }
        

        if (props.location.state && props.location.state.datatable && props.location.state.datatable.search) {
            let tempSearch = { ...this.initialSearchState };
            const search = [...props.location.state.datatable.search];

            search.forEach(element => {
                let temp = { ...element };
                if (typeof temp['value'] === 'string') {
                    temp['value'] = temp['value'].replace(/(^\*)|(\*$)/g, '');
                }
                if (temp['field'] === 'createddate' || temp['field'] === 'todate' ||  temp['field'] === 'fromdate') {
                    temp['value'] = new Date(temp['value']);
                }
                if (temp.field === 'createddate') {
                    if (temp.op === '<=') {
                      tempSearch['todate'] = { ...temp, field: 'createddate' };
                    } else if (temp.op === '>=') {
                      tempSearch['fromdate'] = { ...temp, field: 'createddate' };
                    }
                  } else {
                    tempSearch[temp.field] = temp;
                  }
                tempSearch[temp['field']] = temp;
            });

            this.state['search'] = tempSearch;
            this.state['issearch'] = Boolean(search.length);
            this.state['searchData'] = true;
        }

        this.dataTable = createRef();        
    }

    navigateToCreate = () => {
        let data = {};
        data['datatable'] = this.state.tableData.stateData;
        this.props.history.push({ pathname: '/invoice/create', state: data });
    }
    componentDidMount() {
        this.getLocationList()
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);    

        // Handle Pagination Previous selected dropdown
        if(this.props?.location?.state){
            if(this.props?.location?.state?.PageSize){
                this.setState({
                    PageSize: this.props?.location?.state?.PageSize
                })  
            }
            else{
                this.setState({
                    PageSize: 10
                })
            }
        }
        else{
            this.setState({
                PageSize: 10
            })
        }
    }

    getLocationList = async () => {
        await axios.all([
            axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
        ])
            .then(response => {
                this.locations = response[0].data.data;
                if (this.locations.length == '1') {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        locationlength: this.locations.length,
                        search: {
                            ...this.state.search,
                            locationid: {
                                ...this.state.search.locationid,
                                value: this.locations[0].id
                            },
                        }
                    });
                }
                else {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        locationlength: this.locations.length,
                    })
                }
            })
            .catch(error => {
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }
    
    /* called when accordion clicked */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr)
        row = row.replace(/""/g, '"- - - "')
        row = JSON.parse(row)
        let detail = JSON.parse(row['details']);
        return (
            <div>
                {"items" in detail && detail.items.length ?
                    <div>
                        <div>
                            <div className="d-flex" style={{
                                padding: "0.5% 5% 0.5% 2%",
                                width: "100%"
                            }}>
                                <div style={{ fontWeight: "bold", color: "#af183b", width: "50%" }} className="accordion-text"></div>
                                <div style={{ fontWeight: "bold", color: "#af183b", width: "100%" }} className="accordion-text">{this.accordionHead["title"]}</div>
                                <div style={{ fontWeight: "bold", color: "#af183b", width: "100%" }} className="accordion-text">{this.accordionHead["amount"]}</div>
                                <div style={{ fontWeight: "bold", color: "#af183b", width: "100%" }} className="accordion-text">{this.accordionHead["tax"]}</div>
                                <div style={{ fontWeight: "bold", color: "#af183b", width: "100%" }} className="accordion-text">{this.accordionHead["taxamount"]}</div>
                                <div style={{ fontWeight: "bold", color: "#af183b", width: "100%" }} className="accordion-text">{this.accordionHead["buyerspremium"]}</div>
                                <div style={{ fontWeight: "bold", color: "#af183b", width: "100%" }} className="accordion-text">{this.accordionHead["buyerspremiumamount"]}</div>
                                <div style={{ fontWeight: "bold", color: "#af183b", width: "100%" }} className="accordion-text">{this.accordionHead["grossamount"]}</div>
                            </div>
                            <div style={{ width: "100%", height: .5, backgroundColor: "#e7e4e5" }}></div>
                        </div>
                        <div className="according-item-scroll">
                        {detail.items.map((item, index) => (
                            <div>
                                <div className="d-flex align-items-center" style={{
                                    padding: "0.5% 5% 0.5% 2%"
                                }}>
                                    <div style={{ width: "50%" }} className="accordion-text">
                                        <img src={this.state.displayImage[item.id] ? this.state.displayImage[item.id] : `${process.env.PUBLIC_URL}/static/images/image_thumbnail.png`} alt="thumbnail" height="70" width="70"></img>
                                    </div>
                                    {"title" in item && <div style={{ width: "100%" }} className="accordion-text">{item["title"]}</div>}
                                    {"amount" in item && <div style={{ width: "100%" }} className="accordion-text">$ {parseFloat(item["amount"]).toFixed(2)}</div>}
                                    {"tax" in item && <div style={{ width: "100%" }} className="accordion-text">{item["tax"]} %</div>}
                                    {"taxamount" in item && <div style={{ width: "100%" }} className="accordion-text">$ {parseFloat(item["taxamount"]).toFixed(2)}</div>}
                                    {"buyerspremium" in item && <div style={{ width: "100%" }} className="accordion-text">{item["buyerspremium"]} %</div>}
                                    {"buyerspremiumamount" in item && <div style={{ width: "100%" }} className="accordion-text">$ {parseFloat(item["buyerspremiumamount"]).toFixed(2)}</div>}
                                    {"grossamount" in item && <div style={{ width: "100%" }} className="accordion-text">$ {parseFloat(item["grossamount"]).toFixed(2)}</div>}
                                </div>
                                {detail.items.length - 1 !== index && <div style={{ width: "100%", height: .5, backgroundColor: "#e7e4e5" }}></div>}
                            </div>
                        ))}
                        </div>
                    </div>
                    : ''}
            </div>
        );
    }

    /**
     * 
     * @param event {data, index}
     */
    onOpenAccordion = (event) => {
        let detail = JSON.parse(event.data['details']);
        const itemsIds = detail.items.map(x => x.id);
        this.setState({
            imageList: [],
            displayImage: {}
        }, async () => {
            let filter = [{ field: 'itemid', value: [itemsIds], op: 'IN', join: 'AND' }];
            this.setState({ formLoading: true });
            await axios.post(getSellerUrl(itemimagelist), JSON.stringify({ filter: filter }), getSellerHeaders())
                .then(response => {
                    const data = response.data.data;
                    const displayImage = {};
                    data.forEach(x => { if (x.isdisplayimage === 1) { displayImage[x.itemid] = x.url } });
                    this.setState({
                        imageList: response.data.data,
                        displayImage: displayImage
                    });
                })
                .catch(error => {
                    // toast.error(error.response.data['message']);
                });
        });
    }

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter' && this.state.search.locationid.value && !this.state.errorMessage && !this.state.inputErrorMessage) {
            this.enableSearch()
        }
    }

    customStatus = (values) => {
        return (<span className={`${this.status[values['invoicestatus'].toLowerCase()]}`}>{values['invoicestatus']}</span>);
    }

    customAmount = (values) => {
        return (<span>${parseFloat(values['invoiceamount']).toFixed(2)}</span>);
    }
    customPendingAmount = (values) => {
        return (<span>{values['pendingamount'] != null ? "$" + parseFloat(values['pendingamount']).toFixed(2) : "- - -"}</span>);
    }

    customDate = (value) => {
        if (value['createddate']) {
            return `${ moment.utc(value['createddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };
    getDateInUTCFormat(date) {
        var newDate = moment(date).format('YYYY-MM-DD-hh-mm-ss')
        newDate = newDate.split("-")
        newDate = Date.UTC(Number(newDate[0]), Number(newDate[1] - 1), Number(newDate[2]), Number(newDate[3]), Number(newDate[4]), Number(newDate[5]))
        return (newDate)
    }

    customBuyerName = (values) => {
        let detail = JSON.parse(values['details']);
        if (detail['billingto']) {
            return `${detail['billingto']['lastname']}, ${detail['billingto']['firstname']}`;
        }
    }
    customEmail = (values) => {
        let detail = JSON.parse(values['details']);

        if (detail['billingto'] && "email" in detail['billingto']) {
            return `${detail['billingto']['email']}`;
        }
        else {
            return `- - -`
        }
    }

    editAction = (values) => {
        if(values.type == 'RA' || values.type == 'DG') {
            return false;
        } else {
            return values['invoicestatus'].toLowerCase() === 'unpaid' && parseFloat(values['invoiceamount']).toFixed(2) === parseFloat(values['pendingamount']).toFixed(2) || (values['invoicestatus'].toLowerCase() === 'unpaid' && parseFloat(values['invoiceamount']).toFixed(2) !== parseFloat(values['pendingamount']).toFixed(2) && parseFloat(values['pendingamount']).toFixed(2) > 0);
        }
    };

    /* called when search input changes */
    searchInputChange = (event) => {
        const { name, value } = event.target;
    
        this.setState({
            issearch: true,
            search: {
                ...this.state.search,
                [name]: {
                    ...this.state.search[name],
                    value: value.trimStart()
                }
            }
        }, () => {
            // after state update, run validation on the updated search
            const { search } = this.state;
    
            const locationSelected = !!search.locationid.value;
            const othersEmpty = search.invoicenumber.value ? false : Object.keys(search)
                .filter(key => key !== "locationid")
                .every(key => !search[key].value);
    
            let errormsg = '';
            if (locationSelected && (othersEmpty || this.state.dateRangeError)) {
                errormsg = 'Please enter criteria into at least one additional field or select a date range';
            }
    
            this.setState({ inputErrorMessage: errormsg });
        });
    };
    

    /* set date for date input change */
    setDate = (control, date) => {
        this.setState({
            ...this.state,
            inputErrorMessage: '',
            issearch: true,
            search: {
                ...this.state.search,
                [control]: {
                    ...this.state.search[control],
                    value: date
                },
            }
        }, () => {
            let errorMessage = '';
            let dateError = false
            const { fromdate, todate } = this.state.search;

            if (control === "fromdate" && fromdate.value && todate.value) {
                if (new Date(todate.value) < new Date(fromdate.value)) {
                    this.setState(prev => ({
                        search: {
                            ...prev.search,
                            todate: {
                                ...prev.search.todate,
                                value: null,
                            },
                        },
                    }));
                    return;
                }
            }
    
            if (fromdate.value && todate.value) {
                const start = new Date(fromdate.value);
                const end = new Date(todate.value);
    
                const monthsDiff =
                    (end.getFullYear() - start.getFullYear()) * 12 +
                    (end.getMonth() - start.getMonth());
    
                if (monthsDiff > 12 || (monthsDiff === 12 && end.getDate() > start.getDate())) {
                    errorMessage = "Please select a date range within any 12 month period";
                    dateError = true
                }
            }
    
            this.setState({ errorMessage, dateRangeError: dateError });
        });
    };
    

    /* called when clear all in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            errorMessage: '',
            inputErrorMessage: '',
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
        }, () => {
            this.dataTable.current.searchData();
        });
    }



    /* called when search button clicked */
    enableSearch = () => {
        let search = {};
        search = {
            firstname: { ...this.state.search.firstname, value: this.state.search.firstname.value ? this.state.search.firstname.value + '*' : '' },
            lastname: { ...this.state.search.lastname, value: this.state.search.lastname.value ?  this.state.search.lastname.value + '*' : '' },
            invoicenumber: { ...this.state.search.invoicenumber },
            saletitle: { ...this.state.search.saletitle, value: this.state.search.saletitle.value ? '*' + this.state.search.saletitle.value + '*' : '' },
            fromdate: { ...this.state.search.fromdate, value: this.state.search.fromdate.value ? moment(new Date(this.state.search.fromdate.value)).startOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            todate: { ...this.state.search.todate, value: this.state.search.todate.value ? moment(new Date(this.state.search.todate.value)).endOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            // invoicestatus: { ...this.state.search.invoicestatus, value: this.state.search.invoicestatus.value ? this.state.search.invoicestatus.value : '' },
            itemtitle: { ...this.state.search.itemtitle, value: this.state.search.itemtitle.value ? '*' + this.state.search.itemtitle.value + '*' : '' },
            buyeremail: { ...this.state.search.buyeremail, value: this.state.search.buyeremail.value ? '*' + this.state.search.buyeremail.value + '*' : '' },
            locationid: { ...this.state.search.locationid, value: this.state.search.locationid.value ?  this.state.search.locationid.value: '' },
        }

        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event,
        });
    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    pageSizeChange = (event) => {
        const value = parseInt(event.target.value);
        this.setState({
            PageSize: value
        })
        this.dataTable?.current?.changeSize(value);
    }
    render() {
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                <div className="invoice-search">
                    <div className="invoice-list-search">
                        <Form className="invoice-list-font">
                            <div className="invoice-search-container">
                                <Row>
                                    <Col>
                                        <label>Location *</label>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" disabled>Select location</option>
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Invoice Number</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="invoicenumber" value={this.state.search.invoicenumber.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col>
                                        <label>Sale Title</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="saletitle" value={this.state.search.saletitle.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col>
                                        <label>Item Title</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="itemtitle" value={this.state.search.itemtitle.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col>
                                        <label>From Date</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                                <DatePicker ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.fromdate.value} selected={this.state.search.fromdate.value} onChange={date => { this.setDate('fromdate', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "11%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <label>To Date</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                                <DatePicker minDate={this.state.search.fromdate.value ? this.state.search.fromdate.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.todate.value} selected={this.state.search.todate.value} onChange={date => { this.setDate('todate', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "11%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row  >
                                    <Col>
                                        <label>Buyer First Name</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="firstname" value={this.state.search.firstname.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col>
                                        <label>Buyer Last Name</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="lastname" value={this.state.search.lastname.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col>
                                        <label>Buyer Email Address</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="buyeremail" value={this.state.search.buyeremail.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col></Col>
                                    <Col></Col>
                                    {/* <Col className={"px-1"}>
                                        
                                         <label>Status</label>
                                        <Form.Control as="select" name="invoicestatus" value={this.state.search.invoicestatus.value} onChange={(event) => { this.searchInputChange(event) }}>
                                            <option value='' selected>All</option>
                                            <option value="Paid">Paid</option>
                                            <option value="Unpaid">Unpaid</option>
                                            <option value="Void">Void</option>
                                        </Form.Control> 
                                    </Col> */}
                                    {/* <Col>
                                    <label>Location *</label>
                                    <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" disabled>Please select location</option>
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col> */}
                                    <Col></Col>
                                </Row>
                                <Row className="buttonClass">
                                    <Col>
                                    </Col>
                                    <Col className="d-flex justify-content-center align-items-center">
                                        {(this.state.errorMessage || this.state.inputErrorMessage )&& (
                                            <div className="text-danger text-center"  style={{fontSize: '14px'}}>
                                                {this.state.errorMessage ?  this.state.errorMessage : this.state.inputErrorMessage}
                                            </div>
                                        )}
                                    </Col>

                                    <Col>
                                        <div className="d-flex align-items-center justify-content-end">
                                            <div className="mx-6 text-normal">Display Records Per Page</div>
                                            <div className="page-size-conatiner">
                                                <Form.Control as="select" onChange={this.pageSizeChange}>
                                                    { this.state.PageSize > 0 ? <option selected>{this.state.PageSize ? this.state.PageSize : 10 }</option> : null }
                                                    { this.state.PageSize !== 10 ? <option value={10}>10</option> : null }
                                                    { this.state.PageSize !== 25 ? <option value={25}>25</option>: null }
                                                    { this.state.PageSize !== 50 ? <option value={50}>50</option> : null }
                                                    { this.state.PageSize !== 100 ? <option value={100}>100</option> : null }
                                                </Form.Control>
                                            </div>
                                        <Button className="clear-button"  onClick={() => this.resetState()}>Clear All</Button>
                                        <Button variant="seller-search" disabled={(this.state.search.invoicenumber.value ? false : !this.state.search.locationid.value) || this.state.errorMessage || this.state.inputErrorMessage} onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Form>

                    </div>
                </div>
                {/* <div className="float-control mb-2 ">
                    <Form style={{ width: "20%" }}>
                        <div>
                            <i className="fa fa-search icon"></i>
                            <Form.Control type="text" placeholder="Search" />
                        </div>
                    </Form>
                </div> */}
                <div className="invoice-list">
                    {/* need to add props, as it provides the previous state of datatable */}
                    <Datatable {...this.props} config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null}
                        ref={this.dataTable} onDataUpdate={this.updateTableData} onOpenAccordion={this.onOpenAccordion} />
                </div>
            </div>
        );
    }
}

export default connect(state => state)(InvoiceList);